import { useEffect } from 'react'
import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IAlertBio } from '@/api/notification/getNotificationBio.ts'
import { DISABLE_ALERTS_LIVE_FETCHING } from '@/constant/constant.ts'
import { acquireBioStream } from '@/api/notification/stream/alertStreamRuntime.ts'
import { useAlertStreamPolling } from '@/api/notification/stream/alertStreamStore.ts'

export const apiGetAlertBioLive = async () => {
    return await apiGet<IResAlertBioLive>(`/alert/bio/live`)
}

const useQueryGetAlertBioLive = (enabled = false) => {
    const polling = useAlertStreamPolling('bio')

    useEffect(() => {
        if (!enabled || DISABLE_ALERTS_LIVE_FETCHING) return undefined
        return acquireBioStream()
    }, [enabled])

    return useQuery({
        enabled: enabled,
        queryKey: QueryCacheKeys.notification.getAlertBioLive(),
        // 스트림이 연결돼 있는 동안은 서버가 변경을 밀어 준다. 끊겨 있을 때만 기존 폴링으로 복귀한다.
        refetchInterval: !DISABLE_ALERTS_LIVE_FETCHING && polling ? 1000 : false,
        queryFn: async () => {
            const { data } = await apiGetAlertBioLive()
            return data
        }
    })
}

export default useQueryGetAlertBioLive

export interface IResAlertBioLive {
    bios: IAlertBio[];
}